(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cv-v2-summer50-band"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var banners = document.querySelectorAll('[data-cv-summer50]');

    function fallbackCopy(value) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();

      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      document.body.removeChild(field);
      return copied;
    }

    function initBanner(banner) {
      if (!banner || banner.dataset.ready === 'true') return;
      banner.dataset.ready = 'true';

      var copyButton = banner.querySelector('[data-cv-summer50-copy]');
      var copyLabel = banner.querySelector('[data-cv-summer50-label]');
      var deadline = new Date(banner.getAttribute('data-deadline'));

      function setCopyLabel(text) {
        if (copyLabel) copyLabel.textContent = text;
      }

      function markCopied(success) {
        setCopyLabel(success ? 'Copié' : 'SUMMER50');
        banner.classList.add('is-copied');

        window.setTimeout(function () {
          banner.classList.remove('is-copied');
          setCopyLabel('Copier');
        }, 1800);
      }

      function updateExpiry() {
        if (isNaN(deadline.getTime())) return;

        if (deadline.getTime() - Date.now() <= 0) {
          banner.classList.add('is-expired');
        }
      }

      if (copyButton) {
        copyButton.addEventListener('click', function () {
          var code = 'SUMMER50';

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(function () {
              markCopied(true);
            }).catch(function () {
              markCopied(fallbackCopy(code));
            });
          } else {
            markCopied(fallbackCopy(code));
          }
        });
      }

      updateExpiry();
      window.setInterval(updateExpiry, 60000);
    }

    Array.prototype.forEach.call(banners, initBanner);
  })();
  } catch(e) { console.error(e); }
})();

})();
